import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import UpdateIcon from "@material-ui/icons/Update";
import { Alert } from "reactstrap";
import Checkbox from "@material-ui/core/Checkbox";
import LinearProgress from "@material-ui/core/LinearProgress";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { fetchWithToken } from "../../../../apiUtils";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return -1;
  } else if (b[orderBy] === null) {
    return 1;
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "did", label: "Number" },
  { id: "description", label: "Status" },
  { id: "statusComment", label: "Comment" },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    numSelected,
    rowCount,
    order,
    orderBy,
    onRequestSort,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
            style={{
              color: numSelected
                ? "#464EB8"
                : rowCount % 2
                ? "#808080"
                : "grey",
            }}
          />
        </TableCell>

        {headCells.map((headCell) => (
          <TableCell key={headCell.id} align={"center"} padding={"normal"}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const EditNumberStatusSelectTable = (props) => {
  const {
    classes,
    phoneNumbers,
    searchDetails,
    setSelectedNumbers,
    selectedNumbers,
    statuses,
    setNewRangeRequired,
  } = props;

  const [rows, setRows] = useState(phoneNumbers);
  const [loading, setLoading] = useState(false);
  const [statusComment, setStatusComment] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("did");

  const isSelected = (pn) => selectedNumbers.indexOf(pn) !== -1;

  const rangeFilterHandler = (e) => {
    e.preventDefault();

    var startNumber = e.target.startNumber.value;
    var endNumber = e.target.endNumber.value;

    if (
      startNumber < searchDetails.startNum ||
      startNumber > searchDetails.endNum ||
      endNumber < searchDetails.startNum ||
      endNumber > searchDetails.endNum
    ) {
      sendAlert("Filter out of Range", "warning");
      return;
    }

    setRows(
      phoneNumbers.filter((pn) => pn.did >= startNumber && pn.did <= endNumber)
    );
  };

  const handleFilter = () => {
    var filteredRows = [];

    if (searchDetails.display) {
      filteredRows = rows.filter((row) => {
        return (
          row.did >= searchDetails.startNum && row.did <= searchDetails.endNum
        );
      });
    } else {
      filteredRows = rows.filter((row) => {
        return row;
      });
    }

    return filteredRows;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const selectBoxHandler = (row) => {
    const selectedIndex = selectedNumbers.indexOf(row);
    let newSelectedRow = [];

    if (selectedIndex === -1) {
      newSelectedRow = newSelectedRow.concat(selectedNumbers, row);
    } else if (selectedIndex === 0) {
      newSelectedRow = newSelectedRow.concat(selectedNumbers.slice(1));
    } else if (selectedIndex === selectedNumbers.length - 1) {
      newSelectedRow = newSelectedRow.concat(selectedNumbers.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedRow = newSelectedRow.concat(
        selectedNumbers.slice(0, selectedIndex),
        selectedNumbers.slice(selectedIndex + 1)
      );
    }
    setSelectedNumbers(newSelectedRow);
  };

  const updateSelectedHandler = (e) => {
    setLoading(true);

    if (
      (selectedStatus == "" && statusComment == "") ||
      (selectedStatus == null && statusComment == null)
    ) {
      sendAlert(`No Changes Selected for Update`, "warning");
      setLoading(false);
    } else if (selectedNumbers.length <= 0) {
      sendAlert(`Nothing Selected To Update`, "warning");
      setLoading(false);
    } else {
      updateData(selectedNumbers, selectedStatus);
      setSelectedNumbers([]); // These will clear the previously selected values to avoid resubmitting old data
    }
  };

  const updateData = (selectedRows, selectedStatus) => {
    var tempArr = JSON.parse(JSON.stringify(rows));

    var update = new Promise((resolve, reject) => {
      var count = 0;

      selectedRows.forEach((row, i, array) => {
        if (selectedStatus == "" || selectedStatus == null) {
          var newSubmission = {
            did: row.did,
            rangeId: row.rangeId,
            status: row.status,
            statusComment: statusComment,
          };
        } else {
          var newSubmission = {
            did: row.did,
            rangeId: row.rangeId,
            status: selectedStatus,
            statusComment: statusComment,
          };
        }

        fetchWithToken(`api/PhoneNumber/${row.did}`, "PUT", newSubmission)
          .then((data) => data.json())
          .then((number) => {
            var returnedNumber = number;

            const index = tempArr.findIndex((pn) => {
              return pn.did === returnedNumber.did;
            });

            if (index !== -1) {
              tempArr[index].description =
                returnedNumber.numberStatus.description;
              tempArr[index].statusComment = returnedNumber.statusComment;
              tempArr[index].status = returnedNumber.status;
            }
            count++;
            if (count === array.length) resolve();
          })
          .catch((err) => {
            console.log("err", err);
            setLoading(false);
            reject("failed to update data");
          });
      });
    });

    update.then(() => {
      setSelectedStatus("");
      setStatusComment("");
      setNewRangeRequired((prev) => !prev);
      setRows(tempArr);
      setLoading(false);
    });
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });

    const timer = setTimeout(() => {
      setAlertMessage({
        message: "",
        varient: "",
        active: false,
      });
    }, 8500);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked && selectedNumbers.length <= 0) {
      const newRowSelecteds = rows.map((row) => row);
      setSelectedNumbers(newRowSelecteds);
      return;
    }
    setSelectedNumbers([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          {alertMessage.active && (
            <Alert color={alertMessage.varient}>{alertMessage.message}</Alert>
          )}
          {searchDetails.display && (
            <form onSubmit={rangeFilterHandler}>
              <TableCell style={{ borderBottom: "none" }}>
                Site:
                <div class="input-group mb-4">
                  <input
                    type="text"
                    class="form-control"
                    value={searchDetails.site}
                    style={{ width: "350px" }}
                    id="numberInput"
                    disabled
                  />
                </div>
              </TableCell>

              <TableCell style={{ borderBottom: "none" }}>
                Pool:
                <div class="input-group mb-4">
                  <input
                    type="text"
                    class="form-control"
                    value={searchDetails.pool}
                    style={{ width: "350px" }}
                    id="numberInput"
                    disabled
                  />
                </div>
              </TableCell>

              <TableCell style={{ borderBottom: "none" }}>
                Start
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    name="startNumber"
                    id="startNumber"
                    defaultValue={searchDetails.startNum}
                    style={{ width: "300px" }}
                  />
                </div>
              </TableCell>

              <TableCell style={{ borderBottom: "none" }}>
                End
                <div class="input-group mb-3">
                  <input
                    style={{ marginRight: "25px", width: "300px" }}
                    type="text"
                    class="form-control"
                    name="endNumber"
                    id="endNumber"
                    defaultValue={searchDetails.endNum}
                  />
                  <div class="input-group-append">
                    <Button
                      style={{
                        margin: "10px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                      type="submit"
                      variant="contained"
                      size="small"
                      color="primary"
                    >
                      Filter
                    </Button>
                  </div>
                </div>
              </TableCell>
            </form>
          )}
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"medium"}
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={selectedNumbers.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={rows.length}
                orderBy={orderBy}
                order={order}
                onRequestSort={handleRequestSort}
              />

              <TableBody>
                {stableSort(handleFilter(), getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <CustomTableRow
                        row={row}
                        labelId={labelId}
                        selectBoxHandler={selectBoxHandler}
                        isItemSelected={isItemSelected}
                        index={index}
                        key={row.did}
                        style={{
                          color: isItemSelected
                            ? "#464EB880"
                            : index % 2
                            ? "#808080"
                            : "grey",
                        }}
                      />
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>

          <div class="container" style={{ paddingTop: "15px" }}>
            {loading && (
              <>
                <div style={{ margin: "25px" }}>
                  <span style={{ display: "table", margin: "0 auto" }}>
                    Please Wait For Update to Finish
                  </span>
                  <LinearProgress />
                </div>
              </>
            )}
            <div class="row">
              <div class="col-sm">
                <div class="form-group">
                  <label for="exampleFormControlTextarea1">
                    Status Comment{" "}
                  </label>
                  <textarea
                    class="form-control"
                    name="statusComment"
                    rows="3"
                    value={statusComment}
                    onChange={(e) => setStatusComment(e.target.value)}
                  ></textarea>
                </div>
              </div>

              <div class="col-sm" style={{ paddingTop: "50px" }}>
                <select
                  class="form-control"
                  name="priority"
                  style={{ width: "250px", margin: "auto" }}
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="" hidden>
                    Please Select
                  </option>
                  {statuses
                    .filter((o) => o.value !== 1 || o.description != "Assigned")
                    .map((status) => {
                      return (
                        <option value={status.value} key={status.value}>
                          {status.description}
                        </option>
                      );
                    })}
                </select>
              </div>

              <div class="col-sm" style={{ paddingTop: "45px" }}>
                <div class="btn-group">
                  <Button
                    style={{ margin: "5px" }}
                    variant="contained"
                    color="primary"
                    onClick={() => updateSelectedHandler()}
                  >
                    <UpdateIcon variant="contained" /> Update
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
            onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
            onPageChange={handleChangePage} // Material v > 4
            onChangePage={handleChangePage} // Material v < 4
          />
        </Paper>
      </div>
    </>
  );
};

const CustomTableRow = (props) => {
  const { row, isItemSelected, labelId, index, selectBoxHandler } = props;

  return (
    <>
      <TableRow
        hover
        onClick={() => selectBoxHandler(row)}
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={row.name}
        selected={isItemSelected}
        style={{
          height: "60px",
          background: isItemSelected
            ? "#464EB880"
            : index % 2
            ? "#f8f8f8"
            : "white",
        }}
      >
        <TableCell padding="checkbox">
          <Checkbox
            checked={isItemSelected}
            inputProps={{ "aria-labelledby": labelId }}
            style={{
              color: isItemSelected
                ? "#0072CE"
                : index % 2
                ? "#808080"
                : "grey",
            }}
          />
        </TableCell>
        <TableCell align="center" style={{ width: "100px" }}>
          {row.did}
        </TableCell>
        <TableCell align="center" style={{ width: "100px" }}>
          {row.description}
        </TableCell>
        <TableCell align="center" style={{ width: "100px" }}>
          {row.statusComment}
        </TableCell>
      </TableRow>
    </>
  );
};

export default EditNumberStatusSelectTable;
